"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setAsPhasingOut;
function setAsPhasingOut(model) {
  model.__phasing_out__ = true;
}